import { IApplicationState } from '../../types/redux';

export const selectOffersCount = (state: IApplicationState) => {
  return state.offersCount;
};
